import React, { useEffect, useState } from "react";
import {
	Link,
	Text,
	Grid,
	Card,
	Col,
	VideoPlayer,
	CloudinaryImage,
} from "@website-builder/ui/shared/elements";
import { OverlappingCardWrapper } from "./style";
import { useMediaQuery } from "@react-hook/media-query";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";

const OverlappingCard = (props) => {
	const {
		isDarkBg,
		title,
		description,
		link = "",
		target,
		linkLabel = "",
		cta,
		media: { videoUrl: { url: mediaUrl = "" } = {} } = {},
		topBackgroundColor,
		bottomBackgroundColor,
		contentBackgroundColor,
		isButtonOnDarkBg,
		imageComponent,
		image,
		imageAltTag,
		pageSection,
	} = props;
	// checks for mobile width
	const satisfiesMobileWidth = useMediaQuery(`(max-width: ${TABLET_M_BP}px)`);
	const [isMobile, setIsMobile] = useState(undefined);

	useEffect(() => {
		setIsMobile(satisfiesMobileWidth);
	}, [satisfiesMobileWidth]);

	return (
		<OverlappingCardWrapper
			isDarkBackground={isDarkBg}
			topBackgroundColor={topBackgroundColor}
			bottomBackgroundColor={bottomBackgroundColor}
			contentBackgroundColor={contentBackgroundColor}
			isMobile={isMobile}
		>
			<Grid className="grid-container">
				<Col start={image ? 1 : 3} span={image ? 12 : 8} mdStart={1} mdSpan={6}>
					<Card className="card-container">
						<Grid className={image && !isMobile ? "media-grid-margin" : ""}>
							{image && !isMobile ? (
								<Col start={1} span={6} mdStart={1} mdSpan={6} vAlign="center">
									{imageComponent === "leanerImage" ? (
										<CloudinaryImage
											url={image}
											quality="auto"
											lazyload
											fetchFormat="auto"
											alt={imageAltTag}
										/>
									) : (
										<VideoPlayer
											videoImageUrl={image}
											altTag={imageAltTag}
											mediaUrl={mediaUrl}
											isDarkBg={isButtonOnDarkBg}
										/>
									)}
								</Col>
							) : null}
							<Col
								vAlign="center"
								start={image ? 8 : 1}
								span={image ? 5 : 12}
								mdStart={1}
								mdSpan={6}
							>
								<div className="description-wrapper">
									{title ? (
										<Text
											dark={isDarkBg}
											variant={image ? "headline_3" : "headline_5"}
											tag={image ? "h2" : "h3"}
										>
											{title}
										</Text>
									) : null}
									{description ? (
										<Text
											dark={isDarkBg}
											className="description"
											variant="paragraph_M"
											tag="div"
											dangerouslySetInnerHTML={{ __html: description }}
										/>
									) : null}
									{link && (!image || (image && !isMobile)) ? (
										<Link
											className="link"
											arrowCta
											onClick={(e) =>
												handleCTAClick(
													cta,
													{
														page_section: pageSection,
														redirect_to: link,
														click_text: linkLabel,
													},
													{},
													e,
												)
											}
											href={link}
											target={target}
											darkBg={isDarkBg}
											linkText={linkLabel}
										/>
									) : null}
								</div>
							</Col>
							{image && isMobile ? (
								<Col mdStart={1} mdSpan={6} vAlign="center">
									{imageComponent === "leanerImage" ? (
										<CloudinaryImage
											url={image}
											quality="auto"
											lazyload
											fetchFormat="auto"
											alt={imageAltTag}
										/>
									) : (
										<VideoPlayer
											videoImageUrl={image}
											altTag={imageAltTag}
											mediaUrl={mediaUrl}
											isDarkBg={isButtonOnDarkBg}
										/>
									)}
								</Col>
							) : null}
							{link && isMobile && image ? (
								<Col
									className="mobile-link-container"
									vAlign="center"
									mdStart={1}
									mdSpan={6}
									hAlign="start"
								>
									<Link
										className="link"
										arrowCta
										onClick={(e) =>
											handleCTAClick(
												cta,
												{
													page_section: pageSection,
													redirect_to: link,
													click_text: linkLabel,
												},
												{},
												e,
											)
										}
										href={link}
										target={target}
										darkBg={isDarkBg}
										linkText={linkLabel}
									/>
								</Col>
							) : null}
						</Grid>
					</Card>
				</Col>
			</Grid>
		</OverlappingCardWrapper>
	);
};
export default OverlappingCard;
